import merge from 'lodash/merge';
import { baseTheme, updateTheme } from './index';
import { flattenTheme } from './utils';
var kioskBaseTheme = merge({}, baseTheme, {
  main: {
    fontSizes: {
      lg: "34px",
      md: "28px"
    },
    colours: {
      secondary: {
        d1: '#36AEED'
      },
      tertiary: {
        l5: '#E0E0E0',
        d1: '#B4B4B4'
      }
    }
  }
});
export var getKioskTheme = function getKioskTheme(newTheme) {
  var flatTheme = flattenTheme(updateTheme(kioskBaseTheme, newTheme));
  var componentsTheme = {
    button: {
      minWidth: '180px',
      minHeight: 'auto',
      border: '2px solid transparent',
      borderRadius: flatTheme.rad_xl,
      padding: "".concat(flatTheme.space_3, "px ").concat(flatTheme.space_6, "px"),
      fontSize: flatTheme.fs_md,
      background: flatTheme.cl_pri_base,
      secondary: {
        background: flatTheme.cl_white,
        borderColor: "".concat(flatTheme.cl_pri_base),
        color: flatTheme.cl_pri_base,
        hoverBg: flatTheme.cl_pri_base,
        hoverColor: flatTheme.cl_white
      },
      link: {
        color: flatTheme.cl_sec_d1,
        fontFamily: flatTheme.ff_sec_thin
      },
      outline: {},
      large: {
        fontSize: flatTheme.fs_lg,
        minHeight: '120px',
        minWidth: '128px',
        borderWidth: '3px',
        padding: "".concat(flatTheme.space_2, "px ").concat(flatTheme.space_6, "px")
      },
      disabled: {
        background: flatTheme.cl_ter_l5,
        color: flatTheme.cl_ter_d1,
        borderColor: flatTheme.cl_ter_l5
      },
      customStyle: {}
    },
    pagination: {
      fontSize: '0.875rem',
      marginTop: '16px',
      button: {
        fontFamily: flatTheme.ff_sec_regular,
        color: flatTheme.cl_ter_l2,
        backgroundColor: 'transparent',
        hoverBg: flatTheme.cl_sec_l2,
        borderRadius: '16px',
        height: '32px',
        minWidth: '32px',
        margin: '0 3px',
        padding: '0 6px',
        selected: {
          color: flatTheme.cl_white,
          backgroundColor: flatTheme.cl_sec_d1
        },
        svg: {
          width: '16px',
          height: '16px'
        }
      }
    }
  };
  return Object.assign({}, flatTheme, componentsTheme);
};
export var kioskTheme = getKioskTheme();
export default kioskTheme;